const formatToDecimal = (s) =>
  s
    .toString()
    .replace(/[^.\d]+/g, '')
    .replace(/^([^\\.]*\.)|\./g, '$1');

export default formatToDecimal;
